import initializeForm from './initializeForm';
import setIsNewRecord from './setIsNewRecord';
import toggleModalProduct from './toggleModalProduct';

export default (item) => (dispatch) => {
    let values = {
        email: item.email,
        first_name: item.first_name,
        id: item.id,
        is_enabled: item.is_enabled,
        isOwner: parseInt(item.type) === 0,
        last_name: item.last_name,
        phone: item.phone,
    };

    dispatch(setIsNewRecord(false));
    dispatch(initializeForm(values));
    dispatch(toggleModalProduct(true));
};
